// extracted by mini-css-extract-plugin
module.exports = {"confirmNote":"ConfirmEmail_confirmNote__2Dl_o","confirmButton":"ConfirmEmail_confirmButton__372Ia","login":"ConfirmEmail_login__7hrJH"};